import React, { useMemo } from 'react';
import { shallowMerge } from '@okee-uikit/react-utils';
import { DEFAULT_CONFIG, setConfig, ConfigProvider as OriginConfigProvider } from '@okee-uikit/react-config';
export function ConfigProvider(props) {
  var prefixCls = props.prefixCls,
      popoverArrowOffset = props.popoverArrowOffset,
      direction = props.direction,
      locale = props.locale,
      table = props.table,
      lockScroll = props.lockScroll,
      children = props.children,
      propsDefault = props.propsDefault;
  var value = useMemo(function () {
    var config = shallowMerge(DEFAULT_CONFIG, {
      prefixCls: prefixCls,
      popoverArrowOffset: popoverArrowOffset,
      direction: direction,
      locale: locale,
      table: table,
      lockScroll: lockScroll,
      propsDefault: propsDefault
    });
    setConfig(config);
    return config;
  }, [prefixCls, popoverArrowOffset, direction, locale, table, lockScroll, propsDefault]);
  return React.createElement(OriginConfigProvider, {
    value: value
  }, children);
}